import type { AdminRbacQueryInput } from "../interfaces";
import { AdminRoles } from "../interfaces";
import { getStore } from "./store";

export function canAccessManagementPage(): boolean | null {
    const tenantPlacesManagement = getStore().permissionMap.get(AdminRoles.tenantPlacesManagement);
    const placesBuildingManagement = getStore().permissionMap.get(AdminRoles.placesBuildingManagement);
    const placesDeskManagement = getStore().permissionMap.get(AdminRoles.PlacesDeskManagement);
    
    if (tenantPlacesManagement == null &&
        placesBuildingManagement == null &&
        placesDeskManagement == null) {
        return null; // If no permissions are set, we return null to indicate that we don't know
    }
    
    return !!(tenantPlacesManagement || placesBuildingManagement || placesDeskManagement);
}

export function getPermissionMap(): Map<AdminRbacQueryInput, boolean> {
    return getStore().permissionMap;
}
